


export const handleRouterBack = ({ router }) => {
    if (router) {
        router?.back()
    }
}